// @flow
import React, { useContext, useState } from 'react';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon';
import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';

type Props = {
  icon?: IconName,
  isActive?: boolean,
  label: string,
  subLabel1?: string,
  subLabel2?: string,
  type?: string,
};

export const DefaultLayout = ({ icon, isActive, label, subLabel1, subLabel2, type }: Props) => {
  const [hover, setHover] = useState(false);

  const { isDesktop } = useContext(ReactResponsiveContext);

  if (!label) {
    return null;
  }

  return (
    <div
      className={classnames(
        'focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden py-3 focus:text-white hover:text-white transition-colors',
        { 'bg-turquoise text-white': isActive },
      )}
      onMouseEnter={() => isDesktop && setHover(true)}
      onMouseLeave={() => isDesktop && setHover(false)}
    >
      {!!icon && (
        <Icon
          className={classnames('flex-shrink-0 mx-3', { 'text-blue': !hover && !isActive })}
          name={icon}
          width="1.25rem"
        />
      )}
      <div
        className={classnames('decorator-match flex-1 text-md', {
          'rtl:border-l-1 border-current px-3': !!icon,
        })}
      >
        {!!subLabel1 &&
          !!subLabel2 && (
            <div
              className={classnames('leading-one text-sm', {
                'text-gray-medium': !isActive && !hover,
                'text-current': isActive || hover,
              })}
            >
              {!!subLabel1 && <span className="font-bold uppercase">{subLabel1}</span>}
              {!!subLabel1 && !!subLabel2 && <span> - </span>}
              {!!subLabel2 && <span className="">{subLabel2}</span>}
            </div>
          )}
        <div
          className={classnames({ 'font-brand text-md': type === 'resort' })}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: label }}
        />
      </div>
    </div>
  );
};
